import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SpeedInsights } from "@vercel/speed-insights/react"
import './App.css';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import Header from './Components/Header/Header';
import Inicio from './Components/Body/Inicio/Inicio';
import Sobremi from './Components/Body/Sobremi/Sobremi';
import ConsultoriaNutricional from './Components/Body/Servicios/Servicios';
import PlanesNutricionales from './Components/Body/PlanesNutricionales/Planes';
import NutricionEmpresarial from './Components/Body/Nutricionempresarial/NutricionEmpresarial';
import CharlasNutricionales from './Components/Body/Charlasnutricionales/Charlasnutricionales';
import Testimonios from './Components/Testimonios/Testimonios';
import Footer from './Components/Footer/Footer';
import ServicesModal from './Components/Body/ServicesModal/ServicesModal';
import SocialProof from './Components/SocialProof/SocialProof';
import { PrivacyPolicy, TermsAndConditions } from './Components/PoliticasyTerminos/PoliticasyTerminos';
import './Components/Body/Servicios/ServicesTabs.css';

import NutriShop from './Components/Body/NutriShop/NutriShop';
import AdminPanel from './Components/Admin/AdminPanel';
import Login from './Components/Admin/Login';
import ProtectedRoute from './Components/Admin/ProtectedRoute';

// Componente para manejar páginas no encontradas
const NotFound = () => {
  useEffect(() => {
    document.title = 'Página no encontrada | Nutricionista Mayra Martell';
  }, []);

  return (
    <div className="not-found-container">
      <h1>Página no encontrada</h1>
      <p>La página que buscas no existe. Regresa a la página principal.</p>
    </div>
  );
};

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Función para manejar el scroll suave
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  // Efecto para manejar el scroll al inicio al cargar la página
  useEffect(() => {
    window.onbeforeunload = () => {
      window.scrollTo(0, 0);
    };
  }, []);

  // Efecto para actualizar el título de la página y rastrear vista de página
  useEffect(() => {
    document.title = 'Nutricionista en Lima | Mayra Martell - Asesoría Personalizada';
    // Rastrear vista de página
    window.fbq && window.fbq('track', 'PageView');
  }, []);

  const [activeService, setActiveService] = useState('planes'); // 'personalizada', 'planes', 'charlas', 'empresarial'

  // Función para rastrear la apertura del modal de servicios
  const handleModalOpen = () => {
    setIsModalOpen(true);
    // Rastrear inicio de contacto
    window.fbq && window.fbq('track', 'Contact');
  };

  const MainContent = () => {
    useEffect(() => {
      // Rastrear vista de contenido principal
      window.fbq && window.fbq('track', 'ViewContent', {
        content_name: 'Página Principal',
        content_category: 'Servicios Nutricionales'
      });
    }, []);

    const ServicesSection = () => {
      return (
        <section className="services-container-refactored">
          <div className="services-tabs-container">
            <div className="services-tabs-nav">
              <button
                className={`tab-btn ${activeService === 'personalizada' ? 'is-active-service' : ''}`}
                onClick={() => setActiveService('personalizada')}
              >
                Consultoría Personalizada
              </button>
              <button
                className={`tab-btn ${activeService === 'planes' ? 'is-active-service' : ''}`}
                onClick={() => setActiveService('planes')}
              >
                Planes Nutricionales
              </button>
              <button
                className={`tab-btn ${activeService === 'charlas' ? 'is-active-service' : ''}`}
                onClick={() => setActiveService('charlas')}
              >
                Charlas Nutricionales
              </button>
              <button
                className={`tab-btn ${activeService === 'empresarial' ? 'is-active-service' : ''}`}
                onClick={() => setActiveService('empresarial')}
              >
                Nutrición Empresarial
              </button>
            </div>
          </div>

          <div className="service-content-display">
            {activeService === 'personalizada' && <ConsultoriaNutricional />}
            {activeService === 'planes' && <PlanesNutricionales />}
            {activeService === 'charlas' && <CharlasNutricionales onOpenModal={handleModalOpen} />}
            {activeService === 'empresarial' && <NutricionEmpresarial onOpenModal={handleModalOpen} />}
          </div>
        </section>
      );
    };

    return (
      <>
        <Header scrollToSection={scrollToSection} />
        <main>
          <Inicio onOpenModal={handleModalOpen} />

          <div id="sobre-mi" className="sobre-mi-wrapper">
            <Sobremi onOpenModal={handleModalOpen} />
          </div>

          <div id="servicios" className="servicios-wrapper">
            <ServicesSection />
          </div>

          <div id="nutrishop" className="nutrishop-wrapper">
            <NutriShop />
          </div>

          <div id="testimonios" className="testimonios-wrapper">
            <Testimonios onOpenModal={handleModalOpen} />
          </div>

        </main>
        <div id="contacto">
          <Footer scrollToSection={scrollToSection} />
        </div>

        <SocialProof />
        <SpeedInsights />
      </>
    );
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="root-container">
        <div className="App-container">
          <Routes>
            {/* Ruta principal */}
            <Route path="/" element={<MainContent />} />

            {/* Rutas específicas */}
            <Route path="/politicas" element={<PrivacyPolicy />} />
            <Route path="/terminos" element={<TermsAndConditions />} />

            {/* Rutas de Administración */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            } />

            {/* Redirecciones para URLs antiguas o alternativas */}
            <Route path="/inicio" element={<Navigate to="/" replace />} />
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/index" element={<Navigate to="/" replace />} />

            {/* Manejo de URLs no encontradas */}
            <Route path="*" element={<NotFound />} />
          </Routes>


        </div>
        <ServicesModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </div>
    </Router>
  );
}

export default App;